import getDefaultTraits from './get-default-traits';

export default {
  getDefaultTraits,
};
